import { ESSENCE_COST } from "@personnel/rules-leviathan";

interface EssenceRowProps {
  points: number;
  used: number;
  cost: number;
  remaining: number;
  onChange: (points: number) => void;
  onUsedChange: (used: number) => void;
}

function Stepper({
  label,
  value,
  onChange,
  min = 0,
}: {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
}) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex size-11 shrink-0 items-center justify-center rounded-full border-2 border-leviathan-600 font-display text-lg font-semibold text-leviathan-500 tabular-nums">
        {value}
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-xs tracking-wide text-void-400 uppercase">{label}</span>
        <div className="flex gap-1">
          <button
            type="button"
            onClick={() => onChange(value - 1)}
            disabled={value <= min}
            aria-label={`Lower ${label}`}
            className="size-7 rounded-md border border-void-800 text-void-400 transition-colors hover:border-leviathan-600 hover:text-leviathan-500 disabled:cursor-not-allowed disabled:border-void-800/50 disabled:text-void-800"
          >
            −
          </button>
          <button
            type="button"
            onClick={() => onChange(value + 1)}
            aria-label={`Raise ${label}`}
            className="size-7 rounded-md border border-void-800 text-void-400 transition-colors hover:border-leviathan-600 hover:text-leviathan-500"
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
}

export function EssenceRow({
  points,
  used,
  cost,
  remaining,
  onChange,
  onUsedChange,
}: EssenceRowProps) {
  return (
    <div className="flex flex-col gap-4 rounded-xl border border-void-800 bg-void-900/40 px-4 py-4">
      <div className="flex flex-wrap items-start gap-6">
        <Stepper label="Held" value={points} onChange={onChange} />
        <Stepper label="Used" value={used} onChange={onUsedChange} />

        <div className="ml-auto text-right">
          <div className="text-xs tracking-wide text-void-400 uppercase">Remaining</div>
          <div
            className={`font-display text-lg font-semibold tabular-nums ${
              remaining < 0 ? "text-amber-300" : "text-leviathan-500"
            }`}
          >
            {remaining}
          </div>
        </div>
      </div>

      <p className="text-xs leading-relaxed text-void-400">
        {ESSENCE_COST} Experience each, spent from the same pool as attributes and Qualities —{" "}
        <span className="tabular-nums">{cost} XP</span> committed. Essence does not raise the
        captain&rsquo;s Cost. Used is tracked during play.
      </p>
    </div>
  );
}
